import { useParams } from 'react-router-dom';
import { useTeamNameQuery } from 'apollo/queries/Teams/TEAM_NAME';
var useTeamHeaderTitle = function (section) {
    var _a;
    var id = useParams().id;
    var _b = useTeamNameQuery({
        variables: { id: id },
        skip: !id
    }), data = _b.data, loading = _b.loading;
    var teamName = (_a = data === null || data === void 0 ? void 0 : data.team) === null || _a === void 0 ? void 0 : _a.name;
    return {
        title: teamName ? "".concat(teamName, " - ").concat(section) : section,
        loading: loading
    };
};
export default useTeamHeaderTitle;
